export const conversationFormInputArr = [
  {
    field: "di",
    arr: [
      {
        label: "Reinstatement Quote Allowed",
        field: "direinstatementQuoteAllowed",
        space: 6,
      },
      {
        label: "TS Number",
        field: "ditsNumber",
        space: 6,
      },
      {
        label: "NOD Filed",
        field: "dinodFiled",
        space: 6,
      },
      {
        label: "NOD 90 Day Exp",
        field: "dinod90DayExp",
        space: 6,
      },
      {
        label: "FC Fees and Cost",
        field: "difcFeesAndCost",
        space: 6,
      },
      {
        label: "Original Trustee Sale Date and Time",
        field: "dioriginalTrusteeSaleDateAndTime",
        space: 6,
      },
      {
        label: "Sale Amount",
        field: "disaleAmount",
        space: 6,
      },
      {
        label: "Settlement Good Through",
        field: "disettlementGoodThrough",
        space: 6,
      },
      {
        label: "REO Date",
        field: "direoDate",
        space: 6,
      },
      {
        label: "REO Redemption Expires",
        field: "direoRedemptionExpires",
        space: 6,
      },
      {
        label: "REO to docs for closing",
        field: "direoToDocsForClosing",
        space: 6,
      },
      {
        label: "REO Invoice sent to lender",
        field: "direoInvoiceSentToLender",
        space: 6,
      },
      {
        label: "REO funds received",
        field: "direoFundsReceived",
        space: 6,
      },
      {
        label: "Outside Foreclosure",
        field: "dioutsideForeclosure",
        space: 6,
      },
      {
        label: "TEST Pick List",
        field: "ditestPickList",
        space: 6,
      },
      {
        label: "TEST Pick List Select Required *",
        field: "ditestPickListSelectRequired",
        space: 6,
      },
      {
        label: "TEST Pick List Select",
        field: "ditestPickListSelect",
        space: 6,
      },
      {
        label: "FC Sold 3rd Party",
        field: "difcSold3RdParty",
        space: 6,
      },
      {
        label: "FC 3rd party redemption exp",
        field: "difc3RdPartyRedemptionExp",
        space: 6,
      },
      {
        label: "FC 3rd Party Funds Received",
        field: "difc3RdPartyFundsReceived",
        space: 6,
      },
    ],
  },
  {
    field: "pa",
    arr: [
      {
        label: "Authorized 3rd Party",
        field: "paAuthorized3rdParty",
        space: 6,
      },
    ],
  },
  {
    field: "bk",
    arr: [
      { label: "BK Chp and File Date", field: "BKChpAndFileDate", space: 6 },
      { label: "BK Case No", field: "BKCaseNo", space: 6 },
      { label: "BK Dismissal", field: "BKDismissal", space: 6 },
      { label: "Contact Info", field: "BKContactInfo", space: 6 },
    ],
  },
  {
    field: "dti",
    arr: [
      {
        label: "Del Tax Year",
        field: "dtiDelTaxYear",
        space: 6,
      },
      {
        label: "Del Tax Amount",
        field: "dtiDelTaxAmount",
        space: 6,
      },
    ],
  },
  {
    field: "Hins",
    arr: [
      { label: "InsEffectiveDate", field: "hInsEffectiveDate", space: 6 },
      { label: "InsDeductible", field: "hInsDeductible", space: 6 },
      { label: "InsCoverageAmnt", field: "hInsCoverageAmnt", space: 6 },
      { label: "InsPremium", field: "hInsPremium", space: 6 },
      { label: "InsPaymentStatus", field: "hInsPaymentStatus", space: 6 },
      { label: "InsPayeeCode", field: "hInsPayeeCode", space: 6 },
      {
        label: "InsFirstMrtgeePayeeName",
        field: "hInsFirstMrtgeePayeeName",
        space: 6,
      },
      {
        label: "InsFirstMrtgeePayeeAddress1",
        field: "hInsFirstMrtgeePayeeAddress1",
        space: 6,
      },
      {
        label: "InsFirstMrtgeePayeeAddress2",
        field: "hInsFirstMrtgeePayeeAddress2",
        space: 6,
      },
      {
        label: "InsFirstMrtgeePayeeCity",
        field: "hInsFirstMrtgeePayeeCity",
        space: 6,
      },
      {
        label: "InsFirstMrtgeePayeeState",
        field: "hInsFirstMrtgeePayeeState",
        space: 6,
      },
      {
        label: "InsFirstMrtgeePayeeZip",
        field: "hInsFirstMrtgeePayeeZip",
        space: 6,
      },
      {
        label: "InsFirstMrtgeePayeePhone",
        field: "hInsFirstMrtgeePayeePhone",
        space: 6,
      },
      {
        label: "InsSecondMrtgeePayeeName",
        field: "hInsSecondMrtgeePayeeName",
        space: 6,
      },
      {
        label: "InsSecondMrtgeePayeeAddress",
        field: "hInsSecondMrtgeePayeeAddress",
        space: 6,
      },
      {
        label: "InsSecondMrtgeePayeeCity",
        field: "hInsSecondMrtgeePayeeCity",
        space: 6,
      },
      {
        label: "InsSecondMrtgeePayeeState",
        field: "hInsSecondMrtgeePayeeState",
        space: 6,
      },
      {
        label: "InsSecondMrtgeePayeeZip",
        field: "hInsSecondMrtgeePayeeZip",
        space: 6,
      },
      {
        label: "InsMortgageeUpdatedtoincludeSLS",
        field: "hInsMortgageeUpdatedtoincludeSLS",
        space: 6,
      },
      { label: "InsEntryDate", field: "hInsEntryDate", space: 6 },
      { label: "InsStatus", field: "hInsStatus", space: 6 },
      {
        label: "InsLenderFPIDeclineDate",
        field: "hInsLenderFPIDeclineDate",
        space: 6,
      },
      {
        label: "InsActivePolicyExpirationDate",
        field: "hInsActivePolicyExpirationDate",
        space: 6,
      },
    ],
  },
  {
    field: "sld",
    arr: [
      {
        label: "Sr FC Info Line Phone Nmbr",
        field: "sldSrFCInfoLinePhoneNmbr",
        space: 6,
      },
      { label: "Sr TS", field: "sldSrTS", space: 6 },
      { label: "Sr NOD Filed", field: "sldSrNODFiled", space: 6 },
      { label: "Sr NOD 90 Day", field: "sldSrNOD90Day", space: 6 },
      {
        label: "Sr Original Trustee Sale Date",
        field: "sldSrOriginalTrusteeSaleDate",
        space: 6,
      },
      { label: "Sr Sale Date", field: "sldSrSaleDate", space: 6 },
      { label: "Sr Sale Time", field: "sldSrSaleTime", space: 6 },
      { label: "Sr FC Status", field: "sldSrFCStatus", space: 6 },
    ],
  },
  {
    field: "lp",
    arr: [
      {
        label: "Lis pendens Notice Received Date",
        field: "lpLisPendensNoticeReceivedDate",
        space: 6,
      },
      {
        label: "Lis pendens Notice Sent to Lender Date",
        field: "lpLisPendensNoticeSentToLenderDate",
        space: 6,
      },
      {
        label: "Lis pendens Associated Fees",
        field: "lpLisPendensAssociatedFees",
        space: 6,
      },
    ],
  },
];
